
import Vue from "vue";
import router from "./router";
import App from "./App.vue";
import axios from "axios";
import element from "./element/index";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 注册为全局组件


Vue.use(VueAwesomeSwiper)
Vue.use(element);
Vue.config.productionTip = false;

import * as echarts from "echarts";

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;

new Vue({
  // @ts-ignore
  router,
  render: (h) => h(App),
}).$mount("#app");
